import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Title = styled(Typography)(({ theme }) => ({
  margin: "auto",
  maxWidth: 270,
  [theme.breakpoints.up("mobile")]: {
    maxWidth: "none",
  },
}));

export const Content = styled("div")(({ theme }) => ({
  padding: "10px 40px 34px",
  [theme.breakpoints.up("tablet")]: {
    padding: "54px 134px 34px",
  },
}));
